import createBrowserHistory from 'history/createBrowserHistory';

const browserHistory = createBrowserHistory();

export default browserHistory;


// WEBPACK FOOTER //
// ./src/utils/history.js